
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "8.4.0 (4acb79b41c497c20364b3f5efa11d44f)",
    buildSeed: 1781869144337,
    "wdosbox-x-jspi.wasm": {
        "size": 7716284,
        "gzSize": 2703373
    },
    "wdosbox-x-jspi.js": {
        "size": 230214,
        "gzSize": 54298
    },
    "wdosbox-x.wasm": {
        "size": 7857437,
        "gzSize": 2753426
    },
    "wdosbox-x.js": {
        "size": 229414,
        "gzSize": 55196
    },
    "wdosbox.wasm": {
        "size": 1459705,
        "gzSize": 501642
    },
    "wdosbox.js": {
        "size": 110662,
        "gzSize": 29302
    },
    "wlibzip.wasm": {
        "size": 112483,
        "gzSize": 52219
    },
    "wlibzip.js": {
        "size": 72957,
        "gzSize": 19326
    }
,
};
